<template>
  <div
    class="card card-height animate-fade-in"
    @dragover.prevent="handleDragOver"
    @dragenter.prevent="handleDragEnter"
    @dragleave.prevent="handleDragLeave"
    @drop.prevent="handleDrop"
  >
    <div class="card-header"></div>
    <div
      class="card-body d-flex flex-column justify-content-center align-items-center px-3 px-md-5 mt-n6"
    >
      <p class="text-center h4 h3-md">MI-chaoの世界へようこそ</p>

      <div class="w-100 mt-4 d-flex justify-content-center">
        <div
          class="input-group shadow-lg input-text-wrapper input-wrapper-layout align-items-end"
          :class="{ dragging: isDragging }"
        >
          <div class="file-preview-area" v-if="attachedFiles.length > 0">
            <div class="file-list-wrap">
              <div
                class="file-item-wrap"
                v-for="(file, index) in attachedFiles"
                :key="index"
              >
                <div class="file-content">
                  <template v-if="isImageFile(file)">
                    <img
                      class="file-image-preview"
                      :src="getFilePreview(file)"
                      :alt="file.name"
                    />
                  </template>
                  <template v-else>
                    <i class="fas fa-paperclip me-2 text-secondary"></i>
                    <span class="file-name">{{ file.name }}</span>
                  </template>
                </div>
                <button
                  class="btn-remove"
                  @click="removeFile(index)"
                  title="削除"
                >
                  <i class="fas fa-times"></i>
                </button>
              </div>
            </div>
          </div>

          <!-- 選択モデル -->
          <div
            v-if="selectedModel"
            @click.stop="toggleToolMenu"
            class="selected-model-container"
          >
            <label class="selected-model-chip">
              言語モデル：{{ selectedModelLabel }}
            </label>
          </div>

          <!-- モデル選択メニュー -->
          <div v-if="showToolMenu" class="tool-menu">
            <div class="tool-menu-title">言語モデル</div>

            <div
              v-for="model in selectedModelOptions"
              :key="model.label"
              class="tool-menu-item"
              @click="selectModel(model)"
            >
              {{ model.label }}
            </div>
          </div>

          <div class="input-left-tools">
            <!-- +ボタン -->
            <label
              v-if="false"
              class="btn-plus mb-0"
              @click.stop="toggleToolMenu"
            >
              <i class="fas fa-plus" style="font-size: 18px; color: #555"></i>
            </label>
            <!-- ファイル添付ボタン -->
            <label
              class="mb-0"
              for="file-upload"
              style="cursor: pointer; margin-right: 8px"
            >
              <i
                class="fas fa-paperclip"
                style="font-size: 18px; color: #555"
              ></i>
            </label>
          </div>

          <input
            type="file"
            id="file-upload"
            ref="fileInput"
            multiple
            @change="handleInputFileChange"
            style="display: none"
            accept=".pdf,.csv,.txt,.doc,.docx,.xls,.xlsx,.ppt,.pptx"
          />
          <!-- テキストエリア -->
          <textarea
            :class="[
              'form-control',
              { 'border-0': true, 'shadow-none': true, expanded: focused },
            ]"
            placeholder="気軽に質問してね！"
            @focus="focused = true"
            @blur="focused = false"
            v-model="userInput"
            @keydown.enter.exact.prevent="submitMessage"
            @keydown.enter.ctrl="insertNewLine"
            @paste="handlePaste"
            maxlength="7000"
          ></textarea>
          <!-- Web検索 -->
          <div class="chat-tools-floating">
            <label class="web-search-toggle">
              <i class="fas fa-globe-asia me-1"></i>
              <span>Web検索</span>
              <input
                type="checkbox"
                v-model="isWebSearch"
                @change="notifyWebSearch"
              />
              <span class="toggle-slider"></span>
            </label>
          </div>
          <!-- 送信ボタン -->
          <div
            class="btn btn-icon-only btn-icon-send bg-dark text-white rounded-circle"
            @click="submitMessage"
          >
            <i class="far fa-comment-dots" aria-hidden="true"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import ChatSelectGroup from '@/components/PageLayout/App/ChatSelectGroup.vue'

export default {
  name: 'DefaultCard',
  components: {
    //ChatSelectGroup,
  },
  props: {
    attachedFiles: {
      type: Array,
      required: true,
    },
    model: {
      type: String,
      default: '',
    },
    modelLabel: {
      type: String,
      default: '',
    },
    modelOptions: {
      type: Array,
      required: true,
    },
    personality: {
      type: String,
      default: '',
    },
    webSearch: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    'handle-dragover',
    'handle-drop',
    'input-message',
    'upload-files',
    'remove-file',
    'handle-selected-model',
    'handle-selected-model-label',
    'handle-selected-reasoning-effort',
    'handle-selected-personality',
    'handle-selected-personality-label',
    'handel-web-search',
  ],
  data() {
    return {
      userInput: '',
      focused: false,
      isDragging: false,
      isWebSearch: this.webSearch,
      dragCounter: 0,
      selectedModel: this.model,
      selectedModelLabel: this.modelLabel,
      selectedModelOptions: this.modelOptions,
      selectedPersonality: this.personality,
      selectedPersonalityLabel: '',
      showToolMenu: false,
    }
  },
  methods: {
    toggleToolMenu() {
      this.showToolMenu = !this.showToolMenu
    },
    selectModel(model) {
      this.showToolMenu = false
      this.selectedModel = model.value
      this.selectedModelLabel = model.label
      this.$emit('handle-selected-model', model.value)
      this.$emit('handle-selected-model-label', model.label)
      this.$emit('handle-selected-reasoning-effort', model.effort ?? null)
    },
    handleDragEnter() {
      this.dragCounter++
      this.isDragging = true
    },
    handleDragLeave() {
      this.dragCounter--
      if (this.dragCounter === 0) {
        this.isDragging = false
      }
    },
    handleDrop(event) {
      this.dragCounter = 0
      this.isDragging = false
      this.$emit('handle-drop', event)
      this.$refs.fileInput.value = ''
    },
    handleDragOver(event) {
      this.$emit('handle-dragover', event)
      event.preventDefault()
    },
    handleInputFileChange(event) {
      this.$emit('upload-files', event)
      this.$refs.fileInput.value = ''
    },
    handlePaste(event) {
      const items = event.clipboardData?.items
      if (!items) return

      const files = []

      for (const item of items) {
        if (item.type.startsWith('image/')) {
          event.preventDefault()

          const file = item.getAsFile()
          if (!file) continue

          const ext = file.type.split('/')[1] || 'png'
          const fileName = `screenshot-${Date.now()}.${ext}`

          const newFile = new File([file], fileName, {
            type: file.type,
          })

          files.push(newFile)
        }
      }

      if (files.length === 0) return

      // ここがポイント：input[type=file]風のイベントを作る
      const pseudoEvent = {
        target: {
          files: files,
        },
      }

      // 既存ロジックに流す
      this.handleInputFileChange(pseudoEvent)
    },
    removeFile(index) {
      this.$emit('remove-file', index)
    },
    isImageFile(file) {
      return file.type.startsWith('image/')
    },
    getFilePreview(file) {
      return URL.createObjectURL(file)
    },
    getFileExtension(file) {
      return file.name.split('.').pop().toUpperCase()
    },
    submitMessage() {
      const trimmed = this.userInput.trim()
      if (trimmed) {
        this.$emit('input-message', trimmed)
        this.userInput = ''
      }
    },
    insertNewLine(event) {
      const textarea = event.target
      const start = textarea.selectionStart
      const end = textarea.selectionEnd
      this.userInput =
        this.userInput.substring(0, start) +
        '\n' +
        this.userInput.substring(end)
      this.$nextTick(() => {
        textarea.selectionStart = textarea.selectionEnd = start + 1
      })
    },
    notifyWebSearch() {
      this.$emit('handel-web-search', this.isWebSearch)
    },
  },
  watch: {
    selectedModel(newVal) {
      this.$emit('handle-selected-model', newVal)
    },
    selectedModelLabel(newVal) {
      this.$emit('handle-selected-model-label', newVal)
    },
    selectedPersonality(newVal) {
      this.$emit('handle-selected-personality', newVal)
    },
    selectedPersonalityLabel(newVal) {
      this.$emit('handle-selected-personality-label', newVal)
    },
  },
}
</script>
